import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

import { ConfigService } from 'src/app/shared/services/config.service';
// import { SortService } from 'src/app/shared/services/sort.service';
// import { StorageService } from './storage.service';

import { SharedModule } from '../shared.module';
import { Metadata } from '../models/metadata.interface';


const _log: boolean = false;

@Injectable({providedIn: SharedModule})
export class MetaService {


	constructor(
		private _configService: ConfigService,
		// private _sortService: SortService,
		// private _storageService: StorageService,
		private _metaService: Meta,
		private _titleService: Title
	){
		//console.log('MetaService.constructor');
	}

	/**
	 * Set page title with angular browser title service
	 * TODO-JK: VERIFY THIS WORKS WITH SSR
	 * @param title 
	*/
	public setPageTitle(title: string = null) {
		let pageTitle = this._configService.pageTitleBase;
		if(title) {
			pageTitle = title + ' | ' + pageTitle;
		}
		if(_log) console.log('MetaService.setPageTitle:', pageTitle);
		this._titleService.setTitle(pageTitle);
	}


	/**
	 * Update meta tag
	 * @param tagName 
	 * @param tagContent 
	*/
	public updateMetaTag(tagName: string, tagContent: string) {
		if(_log) console.log('MetaService.updateMetaTag:', tagName, ':', tagContent);
		this._metaService.updateTag({ name: tagName, content: tagContent })
	}


	/**
	 * Update title & metaData, add tags as needed
	 * @param title 
	 * @param metaData 
	*/
	public updateMetaData(title: string = null, metaData: Metadata = null){
		if(_log) console.log('MetaService.updateMetaData.data:', title, metaData);
		//if(_log) console.log('MetaService.updateMetaData.title:', metaData?.metaTitle);
		// let tags = this._metaService.getTags('name');
		// if(_log) console.log('MetaService.tags:', tags);

		const foundMetaTitle = (metaData?.metaTitle && metaData.metaTitle.trim() != '') ? true : false;
		//if(_log) console.log('MetaService.processData.foundMetaTitle:', foundMetaTitle);

		if(!foundMetaTitle) {
			//only use regular title if metaData.metaTitle is not filled in
			if(title && title.trim() != '') {
				this.setPageTitle(title);
			} else {
				this.setPageTitle();
			}
		}


		if(metaData){
			Object.entries(metaData).forEach(
				([key, value]) => {
					//if(_log) console.log('MetaService.processData.tag:', key, ':', value);
					
					if(value.trim() != '') {
						
						if(key == 'metaTitle') {
							this.setPageTitle(value);
						} else {
							this.updateMetaTag(key, value);
						}

					} else {
						this._metaService.removeTag(key);
					}
				}
			);
		} else {
			//should we use default tag values then?
		}

		
		
	}

}